module.exports = __webpack_public_path__ + "img/textLogoHeaderICFA.c1d1bfe.png";